import { routes } from '@/webapi/routes';

export function resoleRoutes(isLocalHost: boolean, baseRoute: string) {
  return isLocalHost ? routes.convertToLocalAiUrl(baseRoute) : baseRoute;
}
